/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.service('Utils', [function () {

        this.getClosest = getClosest;
        this.getClosestElement = getClosestElement;
        this.getQuerystring = getQuerystring;
        this.removeFromQuerystring = removeFromQuerystring;
        this.throttle = throttle;

        function getClosest(el, selector) {
            var matchesFn, parent;
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });
            if (el[matchesFn](selector)) {
                return el;
            }
            while (el !== null) {
                parent = el.parentElement;
                if (parent !== null && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
            return null;
        }

        function getClosestElement(el, target) {
            var closest = null;
            if (el === target) {
                closest = el;
            } else if (el.parentElement !== null) {
                closest = getClosestElement(el.parentElement, target);
            }
            return closest;
        }
        
        function getQuerystring(str) {
            return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
        }

        function removeFromQuerystring() {
            var args = Array.prototype.slice.call(arguments);
            var query = getQuerystring();
            var search = [];
            angular.forEach(query, function (value, key) {
                if (args.indexOf(key) === -1) {
                    search.push(key + '=' + value);
                }
            });
            if (search.length) {
                search = '?' + search.join('&');
            } else {
                search = '';
            }
            if (search !== window.location.search && window.history.replaceState) {                
                window.history.replaceState(null, null, window.location.pathname + search);
                console.log('replaceState', window.location.pathname + search);                
            }
            return search;
        }

        var getNow = Date.now || function () {
            return new Date().getTime();
        };

        function throttle(callback, wait, options) {
            // Returns a function, that, when invoked, will only be triggered at most once
            // during a given window of time. Normally, the throttled function will run
            // as much as it can, without ever going more than once per `wait` duration;
            // but if you'd like to disable the execution on the leading edge, pass
            // `{leading: false}`. To disable execution on the trailing edge, ditto.
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options) options = {};
            var later = function () {
                previous = options.leading === false ? 0 : getNow();
                timeout = null;
                result = callback.apply(context, args);
                if (!timeout) context = args = null;
            };
            return function () {
                var now = getNow();
                if (!previous && options.leading === false) previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = now;
                    result = callback.apply(context, args);
                    if (!timeout) context = args = null;
                } else if (!timeout && options.trailing !== false) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }

    }]);

}());